import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18a7abe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "play gg-play-button" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderItem = _resolveComponent("HeaderItem")!
  const _component_Youtube = _resolveComponent("Youtube")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", _ctx.showPlayer ? 'player-active' : ''])
  }, [
    (!_ctx.showPlayer)
      ? (_openBlock(), _createBlock(_component_HeaderItem, {
          key: 0,
          item: _ctx.item,
          "slide-width": "100%"
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.item.videos.embedded && !_ctx.showPlayer)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "play-container",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPlayer = true))
        }, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.showPlayer)
      ? (_openBlock(), _createBlock(_component_Youtube, {
          key: 2,
          item: _ctx.item
        }, null, 8, ["item"]))
      : _createCommentVNode("", true)
  ], 2))
}